var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityList',{attrs:{"config":_vm.config,"columns":_vm.columns,"custom-query":{ congress: _vm.congressID },"formatted-columns":_vm.formattedColumns,"form-fields":_vm.formFields,"authority":"Congress_Management_Congress"}})}
var staticRenderFns = []

export { render, staticRenderFns }